import FormattedAgentText from '@/components/ChatResponseElements/FormattedAgentText'
import styles from './StreamingText.module.scss'

export default function StreamTail({ text }) {
  if (!text) return null
  return <span className={styles.streamTail}>{text}</span>
}

export function renderStreamBody({ settled, tail, formatted }) {
  if (formatted) {
    return (
      <>
        {settled ? <FormattedAgentText text={settled} /> : null}
        <StreamTail text={tail} />
      </>
    )
  }
  return (
    <>
      {settled}
      <StreamTail text={tail} />
    </>
  )
}
